<template>
    <div id="payment-step">
        <div v-if="!paymentSuccess">
            <div class="order-recap">
                <div class="order-title">
                    <h3>{{$t('subscription.order-summary')}}</h3>
                    <span v-if="billingInfo.planterms_set.interval_count == 1">
                        {{billingInfo.planterms_set.currency + ' ' + billingInfo.planterms_set.price.toLocaleString().replace(/\./g, ' ') + '/' + billingInfo.planterms_set.intervalType}} 
                        <span class="small-vat-notice" v-html="$t('subscription.VAT-notice-small')"></span>
                    </span>
                </div>
                
                <div class="summary-group">
                    <span class="summary-label">{{$t('subscription.form.company')}}: </span>
                    <span>{{billingInfo.vatNumber ? billingInfo.name + ": " + billingInfo.vatNumber : billingInfo.name}} </span>

                    <span class="summary-label">{{$t('subscription.form.name')}}:</span>
                    <span>{{billingInfo.contact.name}}</span>

                    <span class="summary-label">{{$t('subscription.form.email')}}:</span>
                    <span>{{billingInfo.contact.email}}</span>

                    <span class="summary-label">{{$t('subscription.form.address')}}:</span>
                    <span>{{legalAddress}}</span>

                    <span class="summary-label">{{$t('subscription.form.billing-address')}}:</span>
                    <span>{{billingAddress}}</span>
                </div>

                <div class="summary-group">         
                    <span class="summary-label">{{$t('subscription.title')}}:</span>
                    <span>{{plan.name}}</span>

                    <span class="summary-label">{{$t('subscription.contract-period')}}:</span>
                    <span>{{$t('subscription.one-year')}} </span>

                    <span class="summary-label">{{$t('subscription.payment-frequency')}}:</span>
                    <span>{{billingInfo.planterms_set.intervalType == 'month' ? $t('subscription.monthly') : $t('subscription.annually')}}</span>

                    <span class="summary-label">{{$t('subscription.price')}}:</span>
                    <span v-if="billingInfo.planterms_set.intervalCount == 1">
                        {{billingInfo.planterms_set.currency + ' ' + billingInfo.planterms_set.price.toLocaleString().replace(/\./g, ' ') + '/' + billingInfo.planterms_set.intervalType}} 
                        <span class="small-vat-notice" v-html="$t('subscription.VAT-notice-small')"></span> 
                    </span>
                    
                    <span v-if="billingInfo.planterms_set.intervalType == 'month'" class="summary-label"> {{$t('subscription.total-price-1-year')}}</span>
                    <span v-if="billingInfo.planterms_set.intervalType == 'month'">
                        {{billingInfo.planterms_set.currency + ' ' + annualPriceIfMonthly}} 
                        <span class="small-vat-notice" v-html="$t('subscription.VAT-notice-small')"></span> 
                    </span>
                </div>
            </div>
            <div class="payment">
               <div>
                    <h3>{{$t('subscription.card-payment')}}</h3>
                    <stripe-element @generated-token="token => sendBillingInfo(token)" :billingInfo="billingInfo" :paymentError="paymentError"/> 
                    <span class="invoice small" @click="onClickedInvoice()" >{{$t('subscription.invoice-payment')}}</span>
               </div>
            </div>
        </div>
        <div v-else class="success-step">
            <div class="content">
                <div>
                    <h3>{{$t('subscription.success')}}</h3>
                    <p>{{$t('subscription.success-msg')}}</p>
                </div>
                <i class="fa-light fa-check-circle"></i>
            </div>
            <div class="actions">
                <button class="btn btn-primary" @click="toSubscription()">{{$t('subscription.end-flow-btn')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
import StripeElement from "@/components/StripeElement";
import StripePlusElement from "@/components/StripePlusElement";
import ConfirmModal from "@/components/modals/ConfirmModal";
import EventBus from '@/assets/js/eventBus.js'

export default {
name: 'PaymentStep',
  data() {
    return {
        paymentSuccess: false,
        paymentError: false
    }
  },
    props:{
        plan: Object,
        billingInfo: Object,
        annualPriceIfMonthly: [Number, String],
        paymentFrequency: String
    },
    methods:{
        onClickedInvoice(){
            this.$modal.show(ConfirmModal ,{
                title: this.$t('subscription.invoice'),
                description: this.$t('subscription.confirm-invoice-text'),
                confirmButtonText: this.$t('confirm'),
                onConfirm: () => this.sendAsInvoice() 
            },{ width: 350, height: "auto" },)
        },
        sendBillingInfo(cardId){
            this.paymentError = false
            if(cardId){
                this.$emit('set-card-id', cardId)
            }
            let subscriptionData = {...this.billingInfo}
            subscriptionData.planTermsUuid = subscriptionData.planterms_set.uuid
            delete  subscriptionData.planterms_set

            if(subscriptionData.payWithInvoice == false && !subscriptionData.cardId || subscriptionData.payWithInvoice == true && subscriptionData.cardId){
                //If somehow cardinfo was not recieved or both invoice chosen and card recieved 
                this.paymentError = true
            } else{
                this.$store.dispatch("createSubscription", subscriptionData).then(res =>{
                    EventBus.$emit('payment-success');   
                    this.paymentSuccess = true
                    // Send data - if everything went well - proceed to success message
                }).catch(e => {
                    // add error message
                    this.paymentError = true
                })
            }
        },
        sendAsInvoice(){
            this.billingInfo.payWithInvoice = true
            this.sendBillingInfo()
        },
        toSubscription(){
            EventBus.$emit('end-payment-flow');   
        }

    },
    computed: {
        legalAddress(){
            return this.billingInfo.legalAddress.address + ', ' + this.billingInfo.legalAddress.postalCode + ' ' + this.billingInfo.legalAddress.city + ', ' + this.billingInfo.legalAddress.country 
        },
        billingAddress(){
            return this.billingInfo.billingSameAsLegal ? this.$t('subscription.billing-address-is-legal-address') : this.billingInfo.billingAddress.address + ', ' + this.billingInfo.billingAddress.postalCode + ' ' + this.billingInfo.billingAddress.city + ', ' + this.billingInfo.billingAddress.country 
        }
    },
    components:{
        StripeElement
    }
}
</script>

<style lang="less">
#payment-step{
    border-radius: var(--standard-border-radius);
    margin: 0 auto;
    background: #fff;
    display: grid;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

    .order-recap{
        padding: 20px 20px 0px 20px;
        .order-title{
            font-size: 22px;  
            border-bottom: 1px solid #CCC;
            padding: 0 0 20px 0;
            font-weight: bold;

            h3{
                font-size: 18px;
                opacity: .6;
            }
        }

        .summary-group{
            display: grid;
            grid-template-columns: minmax(auto, 150px) auto;
            gap: 10px;
            padding: 20px 0;
            border-bottom: 1px solid #ccc;
            &:last-of-type{
                border-bottom: none;
            } 
            span:not(.summary-label){
                font-weight: 500;
            }
            .summary-label{
                grid-column-start: 0;
                opacity: .7;
            }
           
        }

        .small-vat-notice{
            font-size: 10px;
            font-weight: 400 !important;
            // text-align: right;
            margin-bottom: 0;
            span{
                font-weight: bold;
            }
        }
    }
    .payment{
        background: #fafafa;
        padding: 20px;
        // border-radius: 2px;
        border-radius: var(--standard-border-radius);
        box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.1);
        position: relative;
        display: flex;
        flex-direction: column;

        justify-content: space-between;
        align-items: center;
        h3{
            font-size: 18px;
            opacity: .6;
            margin-bottom: 20px;
        }
        .invoice{
            cursor: pointer;
            text-align: center;
            text-decoration: underline;
            opacity: .5;
        }
    }

    .success-step{
        position: relative;
        padding: 30px;
        display: flex;
        flex-direction: column;
        .content{
            display: flex;
            align-items: center;
            gap: 20px;
        }
        img, svg{
            color: var(--flame);
            height: 60px;
        }
        .actions{
            display: flex;
            flex-direction: row;
            gap: 12px;
        }
    }
}

</style>
